module.exports = __webpack_public_path__ + "img/4_PTFE_SHEETS.05e33499.png";